import { Section, SectionHeading } from "@/components/common/Section";
import { useReveal } from "@/hooks/useReveal";
import { process } from "@/data/content";

function Step({ step, title, desc, index, last }) {
  const ref = useReveal();
  return (
    <div
      ref={ref}
      style={{ transitionDelay: `${index * 80}ms` }}
      data-testid={`process-step-${step}`}
      className="reveal relative flex-1"
    >
      <div className="flex items-center gap-4">
        <span className="font-heading text-4xl font-bold text-gold">{step}</span>
        {!last && <span className="hidden lg:block h-px flex-1 bg-white/15" />}
      </div>
      <h3 className="mt-4 font-heading text-xl text-white">{title}</h3>
      <p className="mt-2 text-sm leading-relaxed text-white/60">{desc}</p>
    </div>
  );
}

export function Process() {
  return (
    <Section id="process" bg="navyDark">
      <SectionHeading
        eyebrow="How We Work"
        title="A clear, five-step delivery process"
        subtitle="Transparent, structured and dependable — from first consultation to final handover."
        align="center"
        light
      />
      <div className="mt-16 flex flex-col lg:flex-row gap-10 lg:gap-6">
        {process.map((p, i) => (
          <Step key={p.step} {...p} index={i} last={i === process.length - 1} />
        ))}
      </div>
    </Section>
  );
}
